import { Col, Row } from "react-bootstrap";
import Image from "react-bootstrap/Image";
import "./BirthdayUser.css";

function BirthdayUser({
  id,
  firstName,
  lastName,
  profilePicture,
  language,
  profileName,
  profileNameEnglish,
  birthDate,
}) {
  const dayjs = require("dayjs");

  return (
    <Col lg={3}>
      <Col className="birthday-user-card">
        <Row className="align-items-center">
          <Col lg={3} className="center">
            <p className="birthday-user-date">{dayjs(birthDate).format("D")}</p>
          </Col>
          <Col lg={9}>
            <h6 className="birthday-user-name">
              {firstName} {lastName}
            </h6>
            <p className="birthday-user-profile">
              {language === "es" ? profileName : profileNameEnglish}
            </p>
          </Col>
        </Row>
      </Col>
    </Col>
  );
}

export default BirthdayUser;
